import LegalDoc from "@/components/LegalDoc";
import { KULLANIM_KOSULLARI_TEXT } from "@/data/legal/kullanimKosullari";

export default function KullanimKosullariPage() {
  return <LegalDoc testid="kullanim-kosullari-page" title="Kullanım Koşulları" text={KULLANIM_KOSULLARI_TEXT} />;
}
